// extracted by mini-css-extract-plugin
export default {"select-time-header-section":"HeaderSection_select-time-header-section__RKrPm","title":"HeaderSection_title__tYFow","header-section":"HeaderSection_header-section__3hOHF"};